import uuid from '@helpers/uuid';
import { NOTIFICATION_TIMER } from '../constants/notifications';

class Notification {
  constructor({ title, message, type, timer }) {
    this.id = uuid();
    this.title = title;
    this.message = message;
    this.type = type || 'success';
    this.timer = timer || NOTIFICATION_TIMER;
  }
}

export default Notification;
